import { IsLoggedInGuard, RequiresPermissionGuard } from '@lexplus-authentication';
import { LexplusPermissionsEnum } from '@lexplus-authentication-api';
import { DetailDrawerType } from '@lexplus-shared-lib';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../../localized-user-routes-const';
import { UserDetailDrawerTypeKey } from '../../../global/models/user-detail-drawer-type-key.model';

/**
 * The single permission that opens the Dokumenten Manager. Spelled out rather than indexed
 * through LEXPLUS_PERMISSIONS_ENUM, whose order the generated client decides.
 */
export const DOKUMENTEN_MANAGER_PERMISSION: LexplusPermissionsEnum = LexplusPermissionsEnum.UserDokumentenmanager;

/**
 * A document as the detail drawer shows it, behind the same permission as the Dokumenten Manager.
 *
 * @param {string} locale - The base language, which localizes the segment
 * @returns {DetailDrawerType} The document's definition for the drawer
 */
export function buildDokumentDetailDrawerType(locale: string): DetailDrawerType<UserDetailDrawerTypeKey> {
  return {
    segment: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_DOCUMENT_MANAGER][locale],
    label: $localize`:@@dokumente.drawer.typ:Datei`,
    drawerLabel: $localize`:@@dokumente.drawer.label:Dokument-Details`,
    loadComponent: () => import('../pages/dokument-detail-page/dokument-detail-page.component').then((m) => m.DokumentDetailPageComponent),
    canActivate: [IsLoggedInGuard, RequiresPermissionGuard],
    data: { requiredPermission: DOKUMENTEN_MANAGER_PERMISSION },
  };
}
